var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan"},[_vm._m(0),_c('span',{staticClass:"plan-price"},[_c('strong',[_vm._v(_vm._s(_vm.price))]),_vm._v(" "),_c('small',[_vm._v("zł/"+_vm._s(_vm.duration)+"min")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"plan-name"},[_c('strong',[_vm._v("Dodatkowa sesja online")])])
}]

export { render, staticRenderFns }